import { IconProps } from './IconProps';

export const BoxOutline = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="26"
      height="28"
      viewBox="0 0 26 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2876_710)">
        <path
          d="M1.63086 21.4246L11.6406 27.0496C12.3242 27.4207 12.9492 27.4304 13.6328 27.0496L23.6426 21.4246C24.7363 20.8093 25.2734 20.1746 25.2734 18.5632V8.30933C25.2734 7.17652 24.834 6.46362 23.8965 5.93628L14.668 0.721435C13.3105 -0.0500487 11.9629 -0.0500487 10.5957 0.721435L1.37695 5.93628C0.439453 6.46362 0 7.17652 0 8.30933V18.5632C0 20.1746 0.537109 20.8093 1.63086 21.4246ZM2.63672 20.0281C1.875 19.6082 1.66016 19.198 1.66016 18.4949V8.68042L11.7871 14.3933V25.1648L2.63672 20.0281ZM22.6367 20.0281L13.4863 25.1648V14.3933L23.6133 8.68042V18.4949C23.6133 19.198 23.3984 19.6082 22.6367 20.0281ZM12.6367 12.8797L2.53906 7.22534L6.77734 4.823L16.8945 10.5066L12.6367 12.8797ZM18.623 9.53003L8.47656 3.8562L11.3672 2.23511C12.2266 1.74683 13.0469 1.73706 13.9062 2.23511L22.7344 7.22534L18.623 9.53003Z"
          fill={props.fill ?? '#000000'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2876_710">
          <rect width="25.6348" height="27.3316" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

